const en = {
    maintenance: {
        pageNotFound: 'Błąd - nie znaleziono strony'
    },
};

export default en;
